module.exports = __webpack_public_path__ + "img/fogyaszd.3016785a.svg";